export default "__VITE_ASSET__ClMqhhAK__"